import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import apiService from "../../services/apiService";

const ROLE_RANK = { viewer:0, analyst:1, employee:1, manager:2, admin:3, superadmin:4 };
const ALL_ROLES = ["employee","analyst","manager","admin"];

export default function InviteUserPanel() {
  const { user } = useAuth();
  const [form, setForm]       = useState({ email:"", firstName:"", lastName:"", role:"employee" });
  const [result, setResult]   = useState(null);
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const availableRoles = ALL_ROLES.filter(r => ROLE_RANK[r] < ROLE_RANK[user?.role]);
  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleInvite = async (e) => {
    e.preventDefault();
    setError(""); setResult(null); setLoading(true);
    try {
      const data = await apiService.invite(form.email, form.firstName, form.lastName, form.role);
      setResult(data);
      setForm({ email:"", firstName:"", lastName:"", role:"employee" });
    } catch (err) {
      setError(err.message || "Invite failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.panel}>
      <h2 style={styles.title}>Invite a Team Member</h2>
      {error && <div style={styles.error}>{error}</div>}
      {result && (
        <div style={styles.success}>
          <p style={{margin:"0 0 8px"}}><strong style={{color:"#4ade80"}}>{result.user.email}</strong> has been invited.</p>
          <p style={{margin:"0 0 8px",color:"#94a3b8",fontSize:"13px"}}>Share this activation code:</p>
          <div style={styles.code}>{result.tempCode}</div>
          <p style={{margin:"8px 0 0",color:"#64748b",fontSize:"12px"}}>
          Expires {new Date(result.expiresAt).toLocaleString()} · They will receive an email with the activation link.
          </p>
          <p style={{margin:"8px 0 0",color:"#f59e0b",fontSize:"12px"}}>
            {result.emailSent ? "Invite email sent." : "Email not enabled — share this code manually."}
          </p>
        </div>
      )}
      <form onSubmit={handleInvite} style={styles.form}>
        <div style={styles.row}>
          <input style={styles.input} name="firstName" placeholder="First name" value={form.firstName} onChange={change} required />
          <input style={styles.input} name="lastName"  placeholder="Last name"  value={form.lastName}  onChange={change} required />
        </div>
        <input style={styles.input} name="email" type="email" placeholder="Email address" value={form.email} onChange={change} required />
        <select style={styles.input} name="role" value={form.role} onChange={change}>
          {availableRoles.map(r => (
            <option key={r} value={r}>{r.charAt(0).toUpperCase() + r.slice(1)}</option>
          ))}
        </select>
        <button style={styles.btn} type="submit" disabled={loading || availableRoles.length === 0}>
          {loading ? "Sending invite..." : "Send Invite"}
        </button>
        {availableRoles.length === 0 && (
          <p style={{color:"#f87171",fontSize:"13px",textAlign:"center"}}>Your role cannot invite other users.</p>
        )}
      </form>
    </div>
  );
}

const styles = {
  panel:   { background:"rgba(15,23,42,0.95)", border:"1px solid rgba(59,130,246,0.2)", borderRadius:"16px", padding:"32px", maxWidth:"480px", fontFamily:"system-ui,-apple-system,sans-serif" },
  title:   { color:"#e2e8f0", fontSize:"20px", fontWeight:"600", marginBottom:"24px" },
  form:    { display:"flex", flexDirection:"column", gap:"16px" },
  row:     { display:"flex", gap:"12px" },
  input:   { flex:1, padding:"12px 16px", background:"rgba(30,41,59,0.8)", border:"1px solid rgba(59,130,246,0.2)", borderRadius:"8px", color:"#e2e8f0", fontSize:"14px", outline:"none", width:"100%" },
  btn:     { padding:"14px", background:"linear-gradient(135deg,#6C63FF,#3b82f6)", border:"none", borderRadius:"8px", color:"white", fontSize:"16px", fontWeight:"600", cursor:"pointer" },
  error:   { background:"rgba(239,68,68,0.15)", border:"1px solid rgba(239,68,68,0.3)", borderRadius:"8px", padding:"12px", color:"#f87171", fontSize:"14px", marginBottom:"8px" },
  success: { background:"rgba(34,197,94,0.1)", border:"1px solid rgba(34,197,94,0.2)", borderRadius:"8px", padding:"16px", marginBottom:"16px" },
  code:    { background:"rgba(108,99,255,0.15)", border:"1px solid rgba(108,99,255,0.3)", borderRadius:"8px", padding:"12px 16px", fontSize:"24px", fontWeight:"700", letterSpacing:"4px", color:"#6C63FF", textAlign:"center", margin:"8px 0" },
};
